<div class="modal-content p-3">
    <div class="modal-body">

        <div class="row">

            <div class="col-12 mb-3">
                <h3><strong>Crear Reporte</strong></h3>
            </div>

            <div class="col-12">
                <p class="font-weight-light">
                    Genera un nuevo reporte consumiendo el scraper de Empresa en un Día. El resultado quedará disponible en el repositorio de transacciones.
                </p>
            </div>

            <form class="col-12" [formGroup]="crearForm" (ngSubmit)="onSubmit()">
                <div class="row w-100 mx-0">
                    <div class="col-sm-12 px-0 my-3">
                        <div class="row">
                            <div class="col-12">
                                <mat-label class="on-primary-fixed-variant font-weight-bold">Tipo de Reporte</mat-label>
                            </div>
                            <div class="col-12 pl-4">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-select disableRipple 
                                        formControlName="tipoReporte" 
                                        id="tipoReporte"
                                    >
                                        <mat-option *ngFor="let option of tipoReporteOptions" [value]="option.value">
                                            {{option.displayName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 px-0 my-3">
                        <div class="row">
                            <div class="col-12">
                                <mat-label class="on-primary-fixed-variant font-weight-bold">RUT</mat-label>
                            </div>
                            <div class="col-12 pl-4">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <input matInput 
                                        placeholder="Ej: 12.345.678-9" 
                                        id="rut" 
                                        type="text"
                                        formControlName="rut"
                                    >
                                    <button type="button" matSuffix mat-icon-button aria-label="Clear" 
                                        (click)="crearForm.get('rut')?.setValue('')" 
                                        *ngIf="crearForm.get('rut')?.value"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field> 
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 mt-5 mb-2 mx-auto d-flex align-items-center justify-content-center">
                        <button mat-flat-button 
                            class="custom-button-secondary mx-2"
                            type="button"
                            (click)="close()"
                        >
                            <mat-icon 
                                aria-hidden="false" 
                                aria-label="Icono camcelar" 
                                fontIcon="close" 
                                class="icon-download mr-3"
                            ></mat-icon>
                            Cancelar
                        </button>
                        <button mat-flat-button 
                            class="custom-button-primary mx-2"
                            type="submit"
                        >
                            <mat-icon 
                                aria-hidden="false" 
                                aria-label="Icono generar" 
                                fontIcon="send" 
                                class="icon-download mr-3"
                            ></mat-icon>
                            Generar
                        </button>
                    </div>
                </div>

            </form>
            
        </div>

    </div>
</div>
